export default {
  methods: {
    getColorRandom(length) {  //随机生成颜色
      let colorAll = []
      let color12 = [
        '#0BB78E', '#4CD177', '#A2CC53', '#F46950', '#FF9800',
        '#FFC107', '#FEEA38', '#589FFD', '#89BBFD', '#DB89ED',
        '#9F7CF4', '#7D8AF6']
      let color20 = [
        '#B4D4FE', '#FDB128', '#89BBFD', '#FF9600', '#589FFD', '#F46950',
        '#1FB4D2', '#FB3A37', '#1DAC91', '#EF6392', '#53CE7B', '#ED51C9', 
        '#A2CC53', '#DB89ED', '#B8ED28', '#9F7CF4', '#FEEA38', '#7D8AF6', 
        '#FDD528', '#4B73D3']
      let color60 = [
        '#B4D4FE', '#FDB128', '#89BBFD', '#FF9600', '#589FFD', '#F46950', 
        '#1FB4D2', '#FB3A37', '#1DAC91', '#EF6392', '#53CE7B', '#ED51C9', 
        '#A2CC53', '#DB89ED', '#B8ED28', '#9F7CF4', '#FEEA38', '#7D8AF6', 
        '#FDD528', '#4B73D3', '#658CBB', '#4D8D78', '#74ACF2', '#94E2C8', 
        '#BCD7FA', '#4CAF50', '#A7F2FF', '#CCF1E4', '#DDFFFF', '#64E7F7', 
        '#B49FCF', '#5EEAD4', '#D1BAD3', '#FDA4AF', '#E2E5F5', '#FBCFE8', 
        '#CFACAC', '#C6A8F5', '#FCEEEE', '#F1E8FF', '#B0B187', '#ECCE00', 
        '#93BFAC', '#FFF301', '#8CA1A8', '#DCFF01', '#BAD3BB', '#9DDC00', 
        '#D3C7BA', '#B6F0B8', '#BFC9E3', '#ECFBCB', '#FFE4B0', '#FF9C70', 
        '#FFDADA', '#FFCAAF', '#CCEAEF', '#FFCF70', '#E8FBFE', '#FFF1D6', ]
        colorAll = length<=12 ? color12 : length>13 && length<=20 ? color20 : length>20 && length <= 60 ? color60 : length > 60 ? [...color12,...color60] : []
      // let color = '';
      // let r = Math.floor(Math.random() * 256);
      // let g = Math.floor(Math.random() * 256);
      // let b = Math.floor(Math.random() * 256);
      // color = `rgb(${r},${g},${b})`;
      // return color;
      colorAll = [...new Set(colorAll)]
      return colorAll
      // return '#'+Math.floor(Math.random()*0xffffff).toString(16);
    },
    render_right(data) {
      let leftChart = [];
      // Object.keys(data.saleNumProportion).forEach(k=>{
      //   leftChart.push({
      //     value: data.saleNumProportion.proportion,
      //     name: data.saleNumProportion.category
      //   })
      // })
      leftChart = data.saleNumProportion.map(v => {
        return {
          value: v.proportion,
          name: v.category
        }
      })
      let rightChart = data.categoryProportion.map(v => {
        return {
          value: v.proportion,
          name: v.category
        }
      })
      //颜色总数
      let colorLength = rightChart.map(v => v.name).length + leftChart.map(v=>v.name).length
      console.log(this.getColorRandom(colorLength));
      console.log(colorLength);
      let colorArr = this.getColorRandom(colorLength)
      let option = {
        color: colorArr,
        // title: {
        //   text: '月均销量数量分布',
        //   top: 10
        // },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: params => {
            // console.log(params);
            const index = params.componentIndex;
            let nameLeft = ''
            if (index == 0) {
              nameLeft = '销量段'
            } else {
              nameLeft = ''
            }
            let indexOf = ['saleNumProportion', 'categoryProportion']
            let name = indexOf[index]
            let str = "";
            // console.log(data[name]);
            let arr = data[name][params.dataIndex]
            str = `${params.marker}${arr.category}${nameLeft}<br/>产品数<span style="inline-block; width:50px; text-algin:right; float:right; font-weight:800; margin-left: 20px;">${arr.productCount || 0}</span><br/>占比<span style="inline-block; width:50px; font-weight:800; text-algin:right; float:right; margin-left: 20px;">${arr.proportion + '%' || 0}</span><br/>`
            return str
          },
        },
        legend: [
          {
            top: '70%',
            right: '80%',
            left: 10,
            data: leftChart.map(v => v.name),
            width: "47%",
            itemWidth: 20,
            textStyle: {
              color: '#fff',
              fontFamily: 'PingFangSC'
            }
          },
          {
            top: '70%',
            left: '50%',
            width: "47%",
            data: rightChart.map(v => v.name).slice(0, 14),
            itemWidth: 20,
            textStyle: {
              color: '#fff',
              fontFamily: 'PingFangSC'
            }
          },
        ],
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: ['40%', '30%'],
            center: ['25%', '45%'],
            minAngle: 5,  //设置扇形的最小占比
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: leftChart
          },
          {
            // name: 'Access From',
            type: 'pie',
            radius: ['40%', '0%'],
            center: ['75%', '45%'],
            minAngle: 5,  //设置扇形的最小占比
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: rightChart.slice(0, 14)
          }
        ]
      };
      let $instance = this.$echarts.init(this.$refs['distribute']);
      $instance.setOption(option, true);
      $instance.on('click', params => {
        this.dialogFormVisibleRight = true
        this.rightDialog(colorArr)
      });
    }
  }
}